import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'regulationtype'

const RegulationTypeModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default RegulationTypeModule



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/index.js